import { useQuery } from '@tanstack/react-query';

import { productsService } from '@/services/products.service';
import { QUERY_KEYS } from '@/utils/constants';

export const useProducts = () =>
  useQuery({
    queryKey: QUERY_KEYS.PRODUCTS.ALL,
    queryFn: productsService.getCatalog,
    staleTime: 5 * 60 * 1000,
  });
